import { render, staticRenderFns } from "./p36.vue?vue&type=template&id=44f6b823&scoped=true&"
import script from "./p36.vue?vue&type=script&lang=js&"
export * from "./p36.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f6b823",
  null
  
)

export default component.exports